<div class="kng-dialog-tooltip">
  <div mat-dialog-content class="kng-dialog-tooltip--container">
    <div class="kng-dialog-tooltip--content">{{data.state.content}}</div>
    <div class="kng-dialog-tooltip--close" >
      <button tabindex="0" mat-button mat-dialog-close (click)="closeTooltip()"><img [src]="data.state.closeIcon.iconPath" [alt]="data.state.closeIcon.altText"></button>
    </div>
  </div>
</div>